<template>
    <div class="flex-col page">
        <div class="flex-col section_1">
            <div style="padding:0 16px; background:white;border-bottom:#E0E0E0 solid 0.5px;">
                <van-tabs v-model="active" color="#02d644" line-height="4px">
                    <van-tab title="全部订单"></van-tab>
                    <van-tab title="待支付"></van-tab>
                    <van-tab title="进行中"></van-tab>
                    <van-tab title="已完结"></van-tab>
                </van-tabs>
            </div>
        </div>
        <div class="flex-col list">
            <div class="flex-col list-item" :key="i" v-for="(item, i) in orderList">
                <CarCardForOrderListVue :carDetails="item" @click="goOrderDetail(item)">
                </CarCardForOrderListVue>
            </div>
            <div v-if="orderList.length == 0" style="text-align:center;margin-top:200px;color:#ccc;">
                暂无数据
            </div>
        </div>
    </div>
</template>

<!-- 1:全部,2:待支付,3:进行中,4:已完结 -->
<script>
import { Tab, Tabs } from 'vant'
import { getOrderList } from '../api'
import CarCardForOrderListVue from '../_components/CarCardForOrderList.vue';
export default {
    components: { Tab, Tabs, CarCardForOrderListVue },
    data() {
        return {
            orderList: [],
            active: 0
        };
    },
    watch: {
        'active': function (val, oldVal) {
            console.log(val)
            this.getOrderList(val + 1)
        }
    },
    methods: {
        goPay(item) {
            console.log({ item })
            this.$router.push({
                path: "/salePassat/pay",
                query: {
                    orderId: item.orderId,
                    from: "orderlist",
                    apiPath: "",// todo
                    returnRouter: "/salePassat/orderlist",
                    payAmount: item.depositPrice,
                },
            }); //传orderId
        },
        goOrderDetail(item) {
            console.log("去订单详情", item)
        },
        goH5Page() {

        },
        getOrderList(state) {
            getOrderList({ "queryOrderState": state ? state : "1", "businessType": "1" }).then(res => {
                this.orderList = res.result
                    ?
                    res.result.map(item => ({
                        ...item,
                        name: item.carTypeName,
                        countDownTime: item.lastPayTime - new Date().getTime()
                    })).filter(item => item.countDownTime > 0)
                    :
                    []
            })
        }
    },
    created() {
        this.getOrderList()
    }
};
</script>

<style scoped lang="scss">
@import '../common.css';
.page {
    padding-top: 0.027rem;
    background-color: #f5f5f5;
    width: 100%;
    overflow-y: auto;
    overflow-x: hidden;
    height: 100%;
    overflow-y: auto;

    .section_1 {
        position: fixed;
        left: 0;
        right: 0;
        top: 0;
        height: 90px;
        background-color: #ffffff;
    }

    .list {
        padding: 105px 0.21rem 0.24rem;

        .list-item {
            padding: 0;
            background-color: #ffffff;
            border-radius: 0.21rem;

            &:not(:first-of-type) {
                margin-top: 0.21rem;
            }
        }
    }

    /deep/ .van-tab {
        &.van-tab--active {
            span {
                font-weight: bold;
            }
        }

        margin-top:24px;
        height:44px;
        line-height:44px;
    }
}
</style>



// WEBPACK FOOTER //
// orderList.vue?ff976690